import { render } from "./ReturnOrderShowComponent.vue?vue&type=template&id=1060ba21&scoped=true"
import script from "./ReturnOrderShowComponent.vue?vue&type=script&lang=js"
export * from "./ReturnOrderShowComponent.vue?vue&type=script&lang=js"

import "./ReturnOrderShowComponent.vue?vue&type=style&index=0&id=1060ba21&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1060ba21"],['__file',"resources/js/components/admin/returnOrders/ReturnOrderShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1060ba21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1060ba21', __exports__)) {
    api.reload('1060ba21', __exports__)
  }
  
  module.hot.accept("./ReturnOrderShowComponent.vue?vue&type=template&id=1060ba21&scoped=true", () => {
    api.rerender('1060ba21', render)
  })

}


export default __exports__